import React from 'react';
import { string, objectOf, any, func, oneOf, arrayOf } from 'prop-types';
import { noop, get, startCase } from 'lodash';
import {
  blueGrey,
  blue,
  cyan,
  deepOrange,
  green,
  grey,
  red,
  teal
} from '@material-ui/core/colors';
import ReactTooltip from 'react-tooltip';

import IconButton from '@material-ui/core/IconButton';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Button from '@material-ui/core/Button';
import AnnoucementIcon from '@material-ui/icons/Announcement';

import MenuWrapper from 'shared-components/MenuWrapper';
import styles from './styles/index.scss';

const stateColors = {
  draft: grey[500],
  paused: grey[500],
  ready: blue[500],
  active: green.A700,
  disabled: grey[500],
  uploaded: cyan[500],
  available: blueGrey[500],
  approved: blue[500],
  deployed: green.A700,
  invalid: red[700],
  disapproved: deepOrange[500],
  rejected: deepOrange[500],
  published: blue[500],
  inactive: grey[500],
  deleted: grey[500]
};

const waitingStates = {
  fetching: blueGrey[500],
  pending: teal[400],
  deploying: green.A700
};

const stateTooltips = {
  build: {
    fetching: 'Build is being received',
    invalid:
      'There was a problem with the build, download the build report for details',
    uploaded:
      'Build has been uploaded, it can now be deployed to Sandbox for testing',
    available: 'Build is available for testing or to submit for approval',
    pending: 'Build is awaiting approval',
    approved: 'Build has been approved, it can now be deployed',
    disapproved:
      'There was a problem with the build, please contact us for details',
    deploying: 'Build is being deployed',
    deployed: 'Build is live in production',
    paused: 'Build has been paused'
  },
  engine: {},
  application: {},
  'data-schema': {}
};

export default class StateLozenge extends React.Component {
  static propTypes = {
    state: string.isRequired,
    type: oneOf(['build', 'engine', 'application', 'data-schema']).isRequired,
    style: objectOf(any),
    onClick: func,
    actions: arrayOf(string),
    onClickAction: func
  };

  static defaultProps = {
    onClickAction: noop
  };

  componentDidMount() {
    // fixme?
    ReactTooltip.rebuild();
  }

  render() {
    return (
      <div>
        {this.props.type === 'build'
          ? <Button
              style={{
                cursor: this.props.onClick ? 'pointer' : undefined,
                paddingRight: this.props.actions ? '0px' : undefined,
                ...this.props.style
              }}
              className={styles[this.props.state]}
              data-tip={get(
                stateTooltips,
                [this.props.type, this.props.state],
                ''
              )}
              onClick={this.props.onClick || noop}
            >
              {this.props.state}
              {Object.keys(waitingStates).includes(this.props.state) &&
                <span className={styles['ellipsis-loading']} />}
              &nbsp;
              <AnnoucementIcon className={styles.icon} />
            </Button>
          : <div
              className={styles['state-chip']}
              style={{
                background: stateColors[this.props.state] || 'white',
                color: waitingStates[this.props.state] || 'white',
                border: `1px solid ${waitingStates[this.props.state] ||
                  'transparent'}`,
                cursor: this.props.onClick ? 'pointer' : undefined,
                paddingRight: this.props.actions ? '0px' : undefined,
                ...this.props.style
              }}
              data-tip={get(
                stateTooltips,
                [this.props.type, this.props.state],
                ''
              )}
              onClick={this.props.onClick || noop}
            >
              <span>
                {this.props.state}
                {Object.keys(waitingStates).includes(this.props.state) &&
                  <span className={styles['ellipsis-loading']} />}
              </span>
              {this.props.actions &&
                <MenuWrapper
                  items={this.props.actions.map(action => ({
                    value: action,
                    label: startCase(action)
                  }))}
                  onClickMenuItem={this.props.onClickAction}
                >
                  <IconButton
                    className={styles['btn-actions']}
                    color="inherit"
                    disableRipple
                  >
                    <ArrowDropDownIcon />
                  </IconButton>
                </MenuWrapper>}
            </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/shared-components/StateLozenge/index.js